import React, {
  useEffect,
  useState,
  useRef,
  useMemo,
  useCallback
} from "react";
import {
  useSearchParams,
  useNavigate,
  useParams,
  json
} from "react-router-dom";
import {
  Grid,
  InputAdornment,
  Tooltip,
  Box,
  CircularProgress
} from "@mui/material";
import {
  MyBreadCrumbs,
  MyTable,
  MyForm,
  MyTextField,
  MyButton,
  MyThaoTac,
  ThongBao,
  RowDetailTable,
  MySearchBox,
  MySelectTime
} from "../DanhMuc/Components";
import Helper from "../../helpers";
import * as Yup from "yup";
import { FastField, useFormikContext } from "formik";
import AddIcon from "@mui/icons-material/Add";
import Api from "../../api2";
import { Close, Search } from "@mui/icons-material";
import FontSize from "../../constants/fontSize";
import { commonReducerSelector } from "../../redux/selector";
import { useSelector } from "react-redux";
const RoutesNhatKyHeThong = [
  {
    path: "",
    main: () => <NhatKyHeThong />
  },
  {
    path: "detail/:id",
    main: () => <DetailNhatKyHeThong />
  }
];

function NhatKyHeThong() {
  const [TBdata, setTBData] = useState([]);
  const [searchForm, setSearchForm] = useState({
    tuKhoa: "",
    limit: 10,
    anchor: null
  });
  const [openModal, setOpenModal] = useState(false);
  const [rawData, setRawData] = useState({});
  const [Count, setCount] = useState();
  const [Loading, setLoading] = useState(false);
  const [SearchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const validationSchema = Yup.object().shape({});
  const formikRef = useRef();

  useEffect(() => {
    const values = formikRef.current.values;
    getApi(values);
  }, []);
  const getRows = (limit, anchor, page) => {
    const values = formikRef.current.values;
    getApi({ ...values, limit, anchor, page });
  };
  const getApi = ({ tuKhoa, limit, anchor, page, ...rest }) => {
    setLoading(true);
    const data = { tuKhoa, limit, anchor, page, ...rest };
    new Api()
      .ListNhatKyHeThong(data)
      .then(res => {
        if (res.code === 200) {
          setTBData(
            Helper.addSttToTableDataSource(res?.data?.records, page, limit)
          );
          setRawData(res.data);
        }
        if (res.data?.count) {
          setCount(res.data?.count);
        }
      })
      .catch(err => {
        //TODO CATCH
        ThongBao({ status: "info", message: "Không thể tải dữ liệu" });
        console.log(err);
      })
      .finally(res => {
        setLoading(false);
      });
  };

  return (
    <div>
      <MyBreadCrumbs
        title={[{ name: "Vận hành" }, { name: "Nhật ký hệ thống" }]}
      />
      <MySearchBox
        name="tuKhoa"
        formikRef={formikRef}
        showState={false}
        initialValues={searchForm}
        onSubmit={values => {
          getApi(values);
        }}
        customButton={[]}
      >
        {({
          handleSubmit,
          setFieldValue,
          handleChange,
          values,
          errors,
          ...propsForm
        }) => (
          <Grid container gap={1} alignItems="flex-end">
            <Grid item xs>
              <MySelectTime
                label="Từ ngày"
                value={values?.ngayLapBieuHourFrom}
                range="from"
                onChange={value => {
                  setFieldValue("ngayLapBieuHourFrom", value);
                }}
              />
            </Grid>
            <Grid item xs>
              <MySelectTime
                label="Đến ngày"
                value={values?.ngayLapBieuHourTo}
                range="to"
                onChange={value => {
                  setFieldValue("ngayLapBieuHourTo", value);
                }}
              />
            </Grid>
          </Grid>
        )}
      </MySearchBox>
      <MyTable
        autofit={true}
        columns={[
          {
            headerName: "STT",
            field: "stt",
            width: "60px",
            suppressSizeToFit: true,
            pinned: "left",
            headerClass: "ag-grid-header-center",
            cellStyle: { justifyContent: "center" }
          },
          {
            field: "tenUser",
            headerName: "Tài khoản",
            minWidth: 180,
            maxWidth: 200,
            cellRenderer: params => {
              return (
                <Tooltip title="Xem chi tiết">
                  <div
                    className="nguonThai-detailPage-tableList-link"
                    onClick={() => {
                      navigate(`detail/${params?.data?.maLog || undefined}`);
                    }}
                  >
                    {params?.value}
                  </div>
                </Tooltip>
              );
            }
          },
          {
            field: "created",
            headerName: "Thời gian thao tác",
            minWidth: 200,
            maxWidth: 300,
            cellRenderer: params => {
              const options = {
                weekday: "long",
                year: "numeric",
                month: "long",
                day: "numeric",
                hour: "numeric",
                minute: "numeric",
                second: "numeric",
                hour12: false // Để hiển thị 24 giờ
              };
              const date = new Date(params?.value * 1000)
                .toLocaleDateString("vi-VN", options)
                .replace("l", "L");

              return (
                <div>
                  {params?.value
                    ? date || Helper.timestempToDateTime(params?.value)
                    : ""}
                </div>
              );
            }
          },
          { field: "moTa", headerName: "Nội dung", minWidth: 200, flex: 1 }
          // { field: 'dataJson', headerName: 'Chi tiết', minWidth: 200, maxWidth: 700, flex: 1 },
          // {
          //     headerName: 'Thao tác',
          //     width: '100px',
          //     suppressSizeToFit: true,
          //     pinned: 'right',
          //     cellRendererFramework: (prams) => <MyThaoTac prams={prams} handleDetail={handleDetail} handleDelete={handleDelete} handleEdit={handleEdit} />,
          // },
        ]}
        data={TBdata}
        loading={Loading}
        pagination={{
          rawData: rawData,
          getRows: getRows,
          setData: setTBData,
          Count: Count
        }}
      />
    </div>
  );
}
function SearchForm(props) {
  const {
    propsForm,
    required,
    handleFormikChange,
    handleAdd,
    onSubmitAPI
  } = props;
  const [searchParams, setSearchParams] = useSearchParams();
  const { values, submitForm } = useFormikContext();
  useEffect(() => {
    if (!handleFormikChange) return;
    handleFormikChange();
  }, [values, submitForm]);
  useEffect(() => {
    const {} = Object.fromEntries(searchParams.entries());
  }, [searchParams]);

  return (
    <Grid container justifyContent={"center"} alignItems={"center"} mb={2}>
      <Grid item xs={6}>
        <MyTextField
          type="search"
          placeholder="Nhập..."
          value={propsForm?.values?.search}
          onChange={e => {
            propsForm.setFieldValue("search", e.target.value);
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <Search
                  sx={{ fontSize: "20px", cursor: "pointer" }}
                  type="submit"
                  onClick={() => {
                    onSubmitAPI(propsForm?.values);
                  }}
                />
              </InputAdornment>
            ),
            sx: {
              height: "33px",
              color: "#3a4c6b",
              fontSize: FontSize.textField,
              "& .MuiOutlinedInput-input": {
                padding: "12px 0px 12px 15px!important"
              }
            }
          }}
        />
      </Grid>
      {/* <Grid item ml={1}>
                <MyButton
                    txt="Tìm kiếm"
                    type="submit"
                    // style={{width: 150, height: 26}}
                    icon={<SearchRoundedIcon />}
                />
            </Grid> */}
      {/* <Grid item xs={6} display={'flex'} justifyContent={'flex-end'}>
                <MyButton
                    txt="Thêm mới"
                    onClick={handleAdd}
                    // style={{width: 150, height: 26}}
                    icon={<AddIcon />}
                />
            </Grid> */}
    </Grid>
  );
}
function DetailNhatKyHeThong() {
  //Var
  const { id } = useParams(null);
  const [data, setData] = useState(null);
  const [xuPhatHanhChinh, setXuPhatHanhChinh] = useState(null);

  const common = useSelector(commonReducerSelector);
  const dataDanhMuc = common.danhmucs.data;
  const dataTinhs = common.tinhs.data;
  const navigate = useNavigate();
  const [Loading, setLoading] = useState(false);
  //Func
  const [value, setValue] = useState("1");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    if (id) {
      setLoading(true);
      new Api()
        .GetNhatKyHeThong({ id })
        .then(res => {
          if (res.code === 200) {
            // if(res?.data?.dataJson) {
            //     const dataJsonParse = JSON.parse(res?.data?.dataJson)
            //     const handleBeautiDataJson = JSON.stringify(dataJsonParse, null, 1)
            //     res.data.dataJson = handleBeautiDataJson
            // }

            setData(res?.data, dataDanhMuc);
          } else {
            ThongBao({ code: res.code });
          }
        })
        .catch(err => {
          ThongBao({ status: "info", message: "Không thể tải dữ liệu" });
          console.log(err);
        })
        .finally(res => {
          setLoading(false);
        });
    }
  }, [id]);

  if (Loading) {
    return (
      <div style={{ position: "absolute", top: "50%", right: "50%" }}>
        <CircularProgress />
      </div>
    );
  }

  return (
    <div>
      <MyBreadCrumbs
        title={[
          { name: "Vận hành" },
          { name: "Nhật ký hệ thống", link: "/nhat-ky-he-thong" },
          { name: `Chi tiết` }
        ]}
      />

      <RowDetailTable
        title={"Chi tiết nhật ký hệ thống"}
        data={data}
        rowDefs={[
          { rowName: "Tài khoản", dataIndex: "tenUser" },
          {
            rowName: "Thời gian thao tác",
            dataIndex: "created",
            rowRender: (value, data) => {
              const options = {
                weekday: "long",
                year: "numeric",
                month: "long",
                day: "numeric",
                hour: "numeric",
                minute: "numeric",
                second: "numeric",
                hour12: false // Để hiển thị 24 giờ
              };
              const date = new Date(value * 1000)
                .toLocaleDateString("vi-VN", options)
                .replace("l", "L");

              return (
                <div>
                  {value ? date || Helper.timestempToDateTime(value) : ""}
                </div>
              );
            }
          },
          { rowName: "Nội dung thực hiện", dataIndex: "moTa" },
          {
            rowName: "Data JSON",
            dataIndex: "dataJson"
          }
        ]}
      />
    </div>
  );
}
export default RoutesNhatKyHeThong;
